
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class Section extends Vue {
  @Prop({ default: "default" }) variant: string;
}
